import React from 'react';


const ProjectItem = ({ project, onClick }) => {
  return (
    <div className="relative p-4 w-full">
      <div
        className="bg-white shadow hover:shadow-xl transition-shadow duration-300 cursor-pointer overflow-hidden group"
        onClick={() => onClick(project)}
      >
        <img src={project.media} alt={project.title} className="w-full h-[350px] object-cover max-sm:h-auto" />
        <div className="absolute inset-3 flex flex-col justify-end items-center text-white 
                        bg-gradient-to-t from-black via-black/70 to-transparent
                        opacity-0 group-hover:opacity-100 transition-opacity duration-300
                        max-sm:opacity-100 max-sm:group-hover:opacity-100">
          <div className="w-full flex flex-col justify-end items-start p-4">
            <h3 className="text-xl font-bold mb-2">{project.title}</h3>
            <div className='flex flex-wrap items-center'>
              {project.technologies.map((tech, index) => (
                <span key={index} className="inline-block bg-blue-400 dark:bg-yellow-500 px-2 py-1 rounded-full mr-2 mb-2 text-sm">
                  {tech}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

  
  export default ProjectItem;
